import React, { useState } from "react";
import "../../Styles/NotesFollowUpTable.css";
import { useNavigate } from "react-router-dom";

const AdminNotesFollowUpTable = () => {
  const navigate = useNavigate();

  const initialData = [
    {
      id: 1,
      subject: "Follow up on drinking water pipeline complaint",
      person: "Bandaru Nageswara Rao",
      mobile: "9876543210",
      category: "Grievance Follow-up",
      priority: "High",
      dueDate: "22-07-2026",
      village: "Gudluru",
      status: "Open",
      icon: "💧",
      iconBg: "note123-icon-red",
    },
    {
      id: 2,
      subject: "Verify CMRF disbursement status",
      person: "Abburi Pullaya",
      mobile: "9123456780",
      category: "Scheme Follow-up",
      priority: "Medium",
      dueDate: "24-07-2026",
      village: "Kandukur",
      status: "In Progress",
      icon: "🧑‍🤝‍🧑",
      iconBg: "note123-icon-orange",
    },
    {
      id: 3,
      subject: "Road repair work site visit confirmation",
      person: "Panchayat Secretary, Ulavapadu",
      mobile: "9988776655",
      category: "Development Work",
      priority: "Low",
      dueDate: "30-07-2026",
      village: "Ulavapadu",
      status: "Completed",
      icon: "🛣️",
      iconBg: "note123-icon-green",
    },
  ];

  const [notes, setNotes] = useState(initialData);

  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All Categories");
  const [priorityFilter, setPriorityFilter] = useState("All Priorities");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 43;

  const resetFilters = () => {
    setSearch("");
    setCategoryFilter("All Categories");
    setPriorityFilter("All Priorities");
    setStatusFilter("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredNotes = notes.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" ||
      item.subject.toLowerCase().includes(searchLower) ||
      item.person.toLowerCase().includes(searchLower);

    const matchesCategory =
      categoryFilter === "All Categories" || item.category === categoryFilter;

    const matchesPriority =
      priorityFilter === "All Priorities" || item.priority === priorityFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesCategory && matchesPriority && matchesStatus;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setNotes((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalNotes = notes.length;
  const highPriority = notes.filter((n) => n.priority === "High").length;

  const dueThisWeek = notes.filter((n) => {
    const [day, month, year] = n.dueDate.split("-").map(Number);
    const due = new Date(year, month - 1, day);
    const today = new Date();
    const weekFromNow = new Date();
    weekFromNow.setDate(today.getDate() + 7);
    return due >= today && due <= weekFromNow;
  }).length;

  const completedCount = notes.filter((n) => n.status === "Completed").length;

  const getPriorityClass = (priority) => {
    switch (priority) {
      case "High":
        return "note123-priority-high";
      case "Medium":
        return "note123-priority-medium";
      case "Low":
        return "note123-priority-low";
      default:
        return "";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Open":
        return "note123-status-open";
      case "In Progress":
        return "note123-status-progress";
      case "Completed":
        return "note123-status-completed";
      default:
        return "";
    }
  };

  const getRowAccent = (priority) => {
    switch (priority) {
      case "High":
        return "note123-accent-red";
      case "Medium":
        return "note123-accent-orange";
      case "Low":
        return "note123-accent-green";
      default:
        return "";
    }
  };

  return (
    <div className="note123-page">
      {/* Header */}
      <div className="note123-header">
        <div>
          <h2 className="note123-title">Notes &amp; Follow Ups</h2>
          <p className="note123-subtitle">
            Track important follow-ups, reminders and notes for better coordination.
          </p>
        </div>

        <button
          className="note123-add-btn"
          onClick={() => navigate("/AdminDashboard/NotesFollowUpForm")}
        >
          <span className="note123-add-icon">+</span> Add New Note
        </button>
      </div>

      {/* Stat Cards */}
      <div className="note123-stats-grid">
        <div className="note123-stat-card note123-stat-card-blue">
          <div className="note123-stat-icon note123-stat-icon-blue">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
              <path d="M14 2v6h6M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="note123-stat-info">
            <span className="note123-stat-label">Total Notes</span>
            <span className="note123-stat-value">{totalNotes}</span>
            <span className="note123-stat-sub note123-sub-up">↑ 18 this month</span>
          </div>
        </div>

        <div className="note123-stat-card note123-stat-card-red">
          <div className="note123-stat-icon note123-stat-icon-red">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M6 3v18M6 4h11l-2.5 3L17 10H6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="note123-stat-info">
            <span className="note123-stat-label">High Priority</span>
            <span className="note123-stat-value">{highPriority}</span>
            <span className="note123-stat-sub note123-sub-up">↑ 6 this month</span>
          </div>
        </div>

        <div className="note123-stat-card note123-stat-card-orange">
          <div className="note123-stat-icon note123-stat-icon-orange">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
              <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="note123-stat-info">
            <span className="note123-stat-label">Due This Week</span>
            <span className="note123-stat-value">{dueThisWeek}</span>
            <span className="note123-stat-sub note123-sub-up">↑ 3 this week</span>
          </div>
        </div>

        <div className="note123-stat-card note123-stat-card-green">
          <div className="note123-stat-icon note123-stat-icon-green">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="note123-stat-info">
            <span className="note123-stat-label">Completed</span>
            <span className="note123-stat-value">{completedCount}</span>
            <span className="note123-stat-sub note123-sub-up">↑ 12 this month</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="note123-filters">
        <div className="note123-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search by Subject or Person..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="note123-select"
          value={categoryFilter}
          onChange={(e) => {
            setCategoryFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Categories</option>
          <option>Grievance Follow-up</option>
          <option>Scheme Follow-up</option>
          <option>Development Work</option>
          <option>General</option>
        </select>

        <select
          className="note123-select"
          value={priorityFilter}
          onChange={(e) => {
            setPriorityFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Priorities</option>
          <option>High</option>
          <option>Medium</option>
          <option>Low</option>
        </select>

        <select
          className="note123-select"
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Open</option>
          <option>In Progress</option>
          <option>Completed</option>
        </select>

        <button className="note123-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Clear Filters
        </button>
      </div>

      {/* Notes List */}
      <div className="note123-list">
        {filteredNotes.length === 0 ? (
          <div className="note123-no-data">No notes found.</div>
        ) : (
          filteredNotes.map((item) => (
            <div
              className={`note123-card ${getRowAccent(item.priority)}`}
              key={item.id}
            >
              <div className={`note123-card-icon ${item.iconBg}`}>
                <span>{item.icon}</span>
              </div>

              <div className="note123-card-main">
                <h3 className="note123-card-subject">{item.subject}</h3>

                <div className="note123-card-meta">
                  <span className="note123-meta-item">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.7" />
                      <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                    </svg>
                    {item.person}
                  </span>

                  <span className="note123-meta-item">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1.9.3 1.8.6 2.7a2 2 0 01-.5 2.1L8 9.7a16 16 0 006 6l1.2-1.2a2 2 0 012.1-.5c.9.3 1.8.5 2.7.6a2 2 0 011.7 2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                    </svg>
                    {item.mobile}
                  </span>

                  <span className="note123-meta-item">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                    </svg>
                    {item.category}
                  </span>

                  <span className="note123-meta-item">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
                    </svg>
                    {item.village}
                  </span>
                </div>
              </div>

              <div className="note123-card-priority">
                <span className={`note123-priority-badge ${getPriorityClass(item.priority)}`}>
                  {item.priority === "High" && "↑ "}
                  {item.priority === "Medium" && "— "}
                  {item.priority === "Low" && "↓ "}
                  {item.priority}
                </span>

                <span className="note123-due-date">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                  {item.dueDate}
                </span>
              </div>

              <div className="note123-card-status">
                <span className={`note123-status-badge ${getStatusClass(item.status)}`}>
                  <span className="note123-status-dot" />
                  {item.status}
                </span>
              </div>

              <div className="note123-card-actions">
                <button className="note123-edit-btn" onClick={() => openEditModal(item)}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      <div className="note123-pagination-bar">
        <span className="note123-pagination-info">
          Showing 1 to {filteredNotes.length} of {totalNotes} entries
        </span>

        <div className="note123-pagination-controls">
          <button
            className="note123-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`note123-page-num ${currentPage === p ? "note123-active" : ""}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="note123-page-dots">...</span>

          <button
            className={`note123-page-num ${currentPage === totalPages ? "note123-active" : ""}`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="note123-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="note123-modal-overlay" onClick={closeEditModal}>
          <div className="note123-modal" onClick={(e) => e.stopPropagation()}>
            <div className="note123-modal-header">
              <h3>Edit Note</h3>
              <button className="note123-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="note123-modal-body" onSubmit={handleEditSave}>
              <div className="note123-form-group">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={editItem.subject}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="note123-form-row">
                <div className="note123-form-group">
                  <label>Person</label>
                  <input
                    type="text"
                    name="person"
                    value={editItem.person}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="note123-form-group">
                  <label>Mobile</label>
                  <input
                    type="text"
                    name="mobile"
                    value={editItem.mobile}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="note123-form-row">
                <div className="note123-form-group">
                  <label>Category</label>
                  <select name="category" value={editItem.category} onChange={handleEditChange}>
                    <option>Grievance Follow-up</option>
                    <option>Scheme Follow-up</option>
                    <option>Development Work</option>
                    <option>General</option>
                  </select>
                </div>

                <div className="note123-form-group">
                  <label>Priority</label>
                  <select name="priority" value={editItem.priority} onChange={handleEditChange}>
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                  </select>
                </div>
              </div>

              <div className="note123-form-row">
                <div className="note123-form-group">
                  <label>Due Date</label>
                  <input
                    type="text"
                    name="dueDate"
                    placeholder="DD-MM-YYYY"
                    value={editItem.dueDate}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="note123-form-group">
                  <label>Village</label>
                  <input
                    type="text"
                    name="village"
                    value={editItem.village}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              </div>

              <div className="note123-form-group">
                <label>Status</label>
                <select name="status" value={editItem.status} onChange={handleEditChange}>
                  <option>Open</option>
                  <option>In Progress</option>
                  <option>Completed</option>
                </select>
              </div>

              <div className="note123-modal-footer">
                <button
                  type="button"
                  className="note123-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="note123-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminNotesFollowUpTable;